import {Alert, type AlertProps, Button, Flex, Text} from '@mantine/core'

export type ErrorBannerButton = {
  title: string
  onClick: () => void
}

type Props = Pick<AlertProps, 'children' | 'title' | 'color'> & {
  buttons: ErrorBannerButton[]
}

export const ErrorBanner = ({children, buttons, title, color = 'red', ...props}: Props) => {
  return (
    <Alert variant={'light'} color={color} mb={15} p={'xs'} {...props}>
      <Flex justify={'center'}>
        <Flex direction={'row'} align={'center'} justify={'space-between'} gap={15} wrap={'wrap'}>
          {title ? (
            <Text fw={'bold'} size={'sm'} c={color}>
              {title}
            </Text>
          ) : null}{' '}
          {children}
          <Flex gap={10}>
            {buttons.map((button) => (
              <Button
                key={button.title}
                variant={'light'}
                color={color}
                size={'compact-sm'}
                fullWidth={false}
                onClick={button.onClick}
              >
                {button.title}
              </Button>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </Alert>
  )
}
